import FolderActionsStep from './FolderActionsStep';

export default FolderActionsStep;
